import { useRouter } from 'vue-router'

import { ROUTE } from '@/constants/routes'
import { useChatStore } from '@/stores/chat'
import { useTelegram } from '@/composables/useTelegram'

/**
 * Диплинк в переписку с поддержкой. Бот, отправляя «вам ответили», открывает
 * мини-апп ссылкой `?startapp=chat_<id комнаты>` — клиент должен попасть сразу
 * в чат, а не на главную и дальше искать его сам.
 *
 * Без id ведём в последнее обращение: у клиента их единицы, и свежее — то,
 * в котором ему и ответили.
 */
const PREFIX = 'chat'

export function useChatDeeplink() {
  const router = useRouter()
  const chatStore = useChatStore()
  const { startParam } = useTelegram()

  async function follow(): Promise<void> {
    const param = startParam.value
    if (!param.startsWith(PREFIX)) return

    /* Telegram разрешает в параметре только буквы, цифры, `_` и `-`,
       поэтому id приезжает как есть, а отделён подчёркиванием или дефисом */
    const roomId = param.slice(PREFIX.length).replace(/^[_-]/, '')
    if (roomId) {
      await router.push(`${ROUTE.chat}/${roomId}`)
      return
    }

    await chatStore.loadRooms()
    await router.push(chatStore.latestId ? `${ROUTE.chat}/${chatStore.latestId}` : ROUTE.chat)
  }

  return { follow }
}
